import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { VolunteerHomeComponent } from './components/volunteer-home/volunteer-home.component';
import { StudentComponent } from './components/student/student.component';
import { ContactComponent } from './components/contact/contact.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';
import { ActivityComponent } from './components/activity/activity.component';
import { ActivityListComponent } from './components/activity-list/activity-list.component';
import { SignupComponent } from './components/signup/signup.component';
import { PetViewComponent } from './components/pet-view/pet-view.component';
import { SobreMiComponent } from './components/sobre-mi/sobre-mi.component';
import { AdminHome } from './components/admin-home/admin-home';
import { ActivityDetail } from './components/activity-detail/activity-detail';
import { StudentDetail } from './components/student-detail/student-detail';
import { StudentProfile } from './components/student-profile/student-profile';
import { QuickActivitiesComponent } from './components/quick-activities/quick-activities';
import { TalkListComponent } from './components/talk-list/talk-list';
import { TalkDetailComponent } from './components/talk-detail/talk-detail';
import { CampaignListComponent } from './components/campaign-list/campaign-list';
import { CampaignDetailComponent } from './components/campaign-detail/campaign-detail';
import { AdoptionListComponent } from './components/adoption-list/adoption-list';
import { AdoptionDetailComponent } from './components/adoption-detail/adoption-detail';
import { IdentificationListComponent } from './components/identification-list/identification-list';
import { IdentificationDetailComponent } from './components/identification-detail/identification-detail';
import { AccreditationListComponent } from './components/accreditation-list/accreditation-list';
import { VolunteerDetail } from './components/volunteer-detail/volunteer-detail';
import { VolunteerProfile } from './components/volunteer-profile/volunteer-profile';
import { MyAccreditationsComponent } from './components/my-accreditations/my-accreditations';
import { PublicIdentificationForm } from './components/public-identification-form/public-identification-form';
import { PublicAdoptionForm } from './components/public-adoption-form/public-adoption-form';
import { PublicCampaignForm } from './components/public-campaign-form/public-campaign-form';
import { PublicTalkForm } from './components/public-talk-form/public-talk-form';
import { OnboardingPhaseComponent } from './components/onboarding/onboarding-phase.component';
import { ExpedienteRecibidoComponent } from './components/onboarding/expediente-recibido.component';
import { BackupComponent } from './components/backup/backup.component';
import { VolunteersHistoryComponent } from './components/volunteers-history/volunteers-history.component';

import { AuthGuard, PublicGuard, OnboardingGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, data: { showInNav: true, label: 'Mi Perfil' } },
      { path: 'my-accreditations', component: MyAccreditationsComponent },
      { path: 'student-profile', component: StudentProfile },
      { path: 'admin/home', component: AdminHome },
      { path: 'admin/quick-activities', component: QuickActivitiesComponent },
      { path: 'admin/talks', component: TalkListComponent },
      { path: 'admin/talks/:id', component: TalkDetailComponent },
      { path: 'admin/adoptions', component: AdoptionListComponent },
      { path: 'admin/adoptions/:id', component: AdoptionDetailComponent },
      { path: 'admin/identifications', component: IdentificationListComponent },
      { path: 'admin/identifications/:id', component: IdentificationDetailComponent },
      {
        path: 'admin/accreditations',
        component: AccreditationListComponent,
      },
      { path: 'admin/backups', component: BackupComponent },
      {
        path: 'volunteer-detail/:id',
        component: VolunteerDetail,
      },
      { path: 'volunteer-home', component: VolunteerHomeComponent, data: { showInNav: true, label: 'Inicio' } },
      { path: 'volunteer-profile', component: VolunteerProfile },
      { path: 'activity-list', component: ActivityListComponent, data: { showInNav: true, label: 'Actividades' } },
      { path: 'activity-list/:id', component: ActivityDetail },
      { path: 'admin/campaigns', component: CampaignListComponent },
      { path: 'admin/campaigns/:id', component: CampaignDetailComponent },
      { path: 'activity', component: ActivityComponent, data: { showInNav: true, label: 'Crear Actividad' } },
      { path: 'student', component: StudentComponent, data: { showInNav: true, label: 'Lista estudiantes' } },
      { path: 'volunteers/history', component: VolunteersHistoryComponent },
      { path: 'contact', component: ContactComponent, data: { showInNav: true, label: 'Contactos' } },
      { path: 'pets', component: PetViewComponent, data: { showInNav: true, label: 'Mascotas' } },
      { path: 'sobre-mi', component: SobreMiComponent, data: { showInNav: true, label: 'Sobre Mi' } },
      { path: 'student/:id', component: StudentDetail },
    ],
  },
  {
    path: 'onboarding',
    canActivate: [OnboardingGuard],
    canActivateChild: [OnboardingGuard],
    children: [
      { path: '', redirectTo: 'phase-1', pathMatch: 'full' },
      { path: 'phase-1', component: OnboardingPhaseComponent },
      { path: 'phase-2', component: OnboardingPhaseComponent },
      { path: 'phase-3', component: OnboardingPhaseComponent },
      { path: 'phase-4', component: OnboardingPhaseComponent },
      { path: 'expediente', component: ExpedienteRecibidoComponent },
    ],
  },
  { path: 'expediente', redirectTo: 'onboarding/expediente', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [PublicGuard],
    children: [
      { path: 'signup', component: SignupComponent },
      { path: 'register', component: SignupComponent },
      { path: 'login', component: LoginComponent },
    ],
  },
  {
    path: 'formularios/adopciones',
    component: PublicAdoptionForm,
  },
  {
    path: 'formularios/platicas',
    component: PublicTalkForm,
  },
  {
    path: 'formularios/campanas',
    component: PublicCampaignForm,
  },
  {
    path: 'formularios/placas',
    component: PublicIdentificationForm,
  },
  {
    path: 'volunteer-request',
    component: SignupComponent,
  },
  { path: '**', component: NotFoundComponent }, // wildcard route for a 404 page
];
